import { send } from '../../../../../src/network/network';
import { type TagGroupDetail } from '../../../../../src/types/TagGroupDetail';
export { type TagGroupDetail as TagGroupResponse };

export async function getTagGroup(tagGroupId: number, query: URLSearchParams) {
  return send<TagGroupDetail>({
    path: `/api/v2/tag_groups/${tagGroupId}/`,
    method: 'GET',
    query,
  });
}
